var _rect, _rect2, _rect3, _path, _rect4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaterPurifier = function SvgWaterPurifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 19,
    x: 2.5,
    y: 0.5,
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 19,
    x: 2.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 1,
    x: 2,
    y: 6,
    fill: "currentColor",
    rx: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12 9a.5.5 0 0 1-.5.5h-3A.5.5 0 0 1 8 9V6.5h4z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    x: 8.5,
    y: 3,
    fill: "currentColor",
    rx: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M10.149 11c-1.231 1.296-2.995 5 0 5 3.078 0 1.231-3.333 0-5Z"
  })));
};
export default SvgWaterPurifier;